import {createStrokeSVG} from './TEMPLATE'

// tabler: circle-plus
export const CirclePlus_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0', 'M9 12h6', 'M12 9v6'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
